// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FWlJ","left":"styles_left__Za4PP","desktopActions":"styles_desktopActions__3f2bg","title":"styles_title__1TORU"};